import { render, staticRenderFns } from "./Article6Content.vue?vue&type=template&id=d374cc8e&scoped=true"
var script = {}
import style0 from "./Article6Content.vue?vue&type=style&index=0&id=d374cc8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d374cc8e",
  null
  
)

export default component.exports